<template>
  <div class='home'>
    <a id='download-pdf' target='_blank' href='/casestudy.pdf' title='Download PDF Version'>
        Download
        <svg viewBox="0 0 48 48" class='icon'>
            <polygon fill="#870000" points="44,27 4,27 1,23 5,19 43,19 47,23 "></polygon>
            <path fill="#E6E6E6" d="M41,47H7c-1.105,0-2-0.895-2-2V3c0-1.105,0.895-2,2-2l24,0l12,12v32C43,46.105,42.105,47,41,47z"></path>
            <path fill="#B3B3B3" d="M31,1v10c0,1.105,0.895,2,2,2h10L31,1z"></path>
            <path fill="#BD0100" d="M45,41H3c-1.105,0-2-0.895-2-2V23h46v16C47,40.105,46.105,41,45,41z"></path>
            <path fill="#FFFFFF" d="M20.071,30.645c0,0.878-0.259,1.556-0.776,2.033c-0.518,0.479-1.252,0.717-2.205,0.717h-0.596V36h-2.122 v-7.853h2.718c0.992,0,1.737,0.217,2.234,0.649C19.822,29.23,20.071,29.847,20.071,30.645z M16.494,31.666h0.387 c0.319,0,0.572-0.09,0.76-0.27c0.188-0.179,0.282-0.426,0.282-0.74c0-0.53-0.293-0.795-0.881-0.795h-0.548V31.666z"></path>
            <path fill="#FFFFFF" d="M27.988,31.907c0,1.311-0.361,2.32-1.083,3.029C26.184,35.646,25.17,36,23.863,36h-2.541v-7.853h2.718 c1.26,0,2.233,0.322,2.919,0.967C27.645,29.759,27.988,30.689,27.988,31.907z M25.786,31.982c0-0.72-0.142-1.253-0.427-1.601 c-0.284-0.348-0.717-0.521-1.297-0.521h-0.618v4.398h0.473c0.645,0,1.117-0.188,1.418-0.562S25.786,32.752,25.786,31.982z"></path>
            <path fill="#FFFFFF" d="M31.484,36h-2.089v-7.853h4.641v1.702h-2.551v1.499h2.353v1.702h-2.353V36z"></path>
        </svg>
    </a>
    <full-page :options='options' ref='fullpage'>

            <!-- Planet of The Apes -->

            <section class='section pota-cover' data-cover data-anchor='bridging-audience-planet-of-the-apes'>
                <figure class='section-bg pota-bg'>
                    <img src='@/assets/images/pota-carlos.png'  class='pota-carlos'>
                </figure>
                <div class='section-content'>
                    <h1 class='section-title'>
                        <span class='ip-title'>Program</span>
                        <span class='sec-title'>Planet of the Apes</span>
                    </h1>
                    <div class='section-text'>
                        <h4>Goal</h4>
                        <p>Extend IP Relevance between Films, Launch 5 Planet of the Apes Motion Books on Madefire for Fox, Drive Foot Traffic & Engagement for Madefire VR Demo at NY ComicCon</p>
                    </div>
                    <img src='@/assets/images/pota-logos.png'>
                </div>
            </section>

            <section class='section pota fixed-titles'
                data-anchor='bridging-audience-planet-of-the-apes-tiered-activation' 
                data-title-left='Tiered Activation' 
                data-title-top='Bridging Audience'
                data-title-ip='Planet Of The Apes'
                data-video
                data-slides>
                <figure class='section-bg'/>

                <div data-video class="slide pota-1">
                    <div class='section-content'>
                        <p class='large'>5 Fully Illustrated Extensive Motion & Sound Books</p>
                    </div>
                    <div class='section-media'>
                        <video ref='videoPOTA' 
                            poster='@/assets/images/pota-video-cover.jpg'
                            preload 
                            loop 
                            src='@/assets/video/pota.mp4'/>
                        <div class='image-set' ref='potaBooks'>
                            <span><img src='@/assets/images/pota-1.png'></span>
                            <span><img src='@/assets/images/pota-2.png'></span>
                            <span><img src='@/assets/images/pota-3.png'></span>
                            <span><img src='@/assets/images/pota-4.png'></span>
                            <span><img src='@/assets/images/pota-5.png'></span>
                        </div>
                    </div>               
                </div>
                <div class="slide pota-2">
                     <div class='section-content'>
                        <p class='large'>2 NY ComicCon Experience Activations</p>
                    </div>
                    
                    <div class='section-media'>
                        <figure class='pota-img pota-nycc-1'/>
                        <figure class='pota-img pota-nycc-2'/>
                    </div>           
                </div>
                <div data-video class="slide pota-3">
                    <div class='section-content'>
                        <p class='large'>1 Custom Microsite <br>& Creative Challenge</p>
                    </div>
                    
                    <div class='section-media'>
                        <video ref='videoPOTAmicrosite' 
                            poster='@/assets/images/pota-video-microsite.jpg'
                            preload 
                            loop 
                            src='@/assets/video/microsite.mp4'/>
                    </div>
                    <figure class='section-bg bg-sf'/> 
                    <div class='image-set'>
                        <img src='@/assets/images/pota-icon-1.png'>
                        <img src='@/assets/images/pota-icon-2.png'>
                        <img src='@/assets/images/pota-icon-3.png'>
                        <img src='@/assets/images/pota-icon-4.png'>
                    </div>
                </div>
                <div data-video class="slide pota-4">
                    <div class='section-content'>
                        <p class='large'>Native Advertising, Parallax Motion Book, Content Clip</p>
                    </div>
                    
                    <div class='section-media'>
                        <img src='@/assets/images/pota-ad.png' class='pota-ad'>
                        <video ref='videoPOTABook' 
                            poster='@/assets/images/pota-video-cover.jpg'
                            preload 
                            loop 
                            src='@/assets/video/pota.mp4'/>
                        <img src='@/assets/images/pota-content-clip.jpg' class='pota-content-clip'>
                    </div>
                </div>
                <div class="slide pota-5">
                     <div class='section-content'>
                        <p class='large'>Influencer Program, Social Media Campaign, Community Featured Messaging & Announcements</p>
                    </div>
                    <div class='section-media'>
                        <img src='@/assets/images/pota-messaging.jpg' class='pota-messaging'/>
                        <div class='row'>
                            <img src='@/assets/images/pota-fb.jpg' class='pota-fb'/>
                            <img src='@/assets/images/pota-twitter.jpg' class='pota-twitter'/>
                        </div>
                    </div>
                </div>
                <div class="slide pota-6">
                    <div class='section-content'>
                        <p class='large'>Artist Engagement & Management</p>
                    </div>
                    
                    <div class='section-media'>
                        <figure class='pota-img pota-artist-1'/>
                        <figure class='pota-img pota-artist-2'/>
                    </div>
                </div>
            </section>

            <!-- Dungeons & Dragons -->

            <section class='section dd-cover' data-cover data-anchor='the-content-loop-dungeons-and-dragons'>
                <figure class='section-bg dd-bg'/>
                <div class='section-content'>
                    <h1 class='section-title'>
                        <span class='sec-title'>The Content Loop</span>
                        <span class='ip-title'>Dungeons & Dragons</span>
                    </h1>
                    <div class='section-text'>
                        <h4>Goal</h4>
                        <p>Create Relevance for New Brand and its Alignment with Gary Gygax</p>
                    </div>
                </div>
            </section>

            <section class='section dd-1 fixed-titles'
                data-anchor='the-content-loop-dungeons-and-dragons-1' 
                data-title-top='The Content Loop' 
                data-video
                data-title-ip='Dungeon & Dragons'>

                <figure class='section-bg'>
                    <p class='medium'>Engagement Rate: <span class='x-large'><span>1</span><span>4</span><span>%</span></span></p>
                    <p class='medium'>With a site less than one month old and not fully ramped up on traffic, the content strategy pulled comments from highly relevant Gygax fans who ultimately began to follow the brand.</p>
                </figure>

                <div class='section-content'>
                    <p class='list medium'>Essay</p>
                    <p class='list medium'>Social Media Promotion</p>
                    <p class='list medium'>Audience Discussion on Facebook</p>
                    <p class='list medium'>Visual Challenge on Pinterest & Imgur</p>
                    <p class='list medium'>Social Media Monitoring & Community Building</p>
                </div>

                <div class='section-media'>
                    <svg viewBox='0 0 270 542' class='dd-phone'>
                    <path d='M341.845,2193.09v416.95H107.216V2193.09H341.845m0.626-.63H106.591v418.2h235.88v-418.2h0ZM224.735,2657.1a19.56,19.56,0,1,1,19.576-19.56A19.587,19.587,0,0,1,224.735,2657.1Zm0-38.49a18.93,18.93,0,1,0,18.95,18.93A18.959,18.959,0,0,0,224.735,2618.61Zm102.453,52.38H122.29c-16.592,0-30.09-13.14-30.09-29.3V2158.4a28.812,28.812,0,0,1,8.874-20.76,30.211,30.211,0,0,1,21.216-8.63h204.9a29.569,29.569,0,0,1,29.673,29.39v483.29a28.942,28.942,0,0,1-8.663,20.72A29.684,29.684,0,0,1,327.188,2670.99Zm-204.9-541.35a29.646,29.646,0,0,0-20.78,8.44,28.226,28.226,0,0,0-8.684,20.32v483.29c0,15.81,13.217,28.67,29.464,28.67h204.9a29.07,29.07,0,0,0,20.57-8.39,28.334,28.334,0,0,0,8.478-20.28V2158.4a28.937,28.937,0,0,0-29.048-28.76H122.29Zm120.385,35.63h-36.6a1.875,1.875,0,1,1,0-3.75h36.6A1.875,1.875,0,1,1,242.675,2165.27Zm-36.6-3.13a1.25,1.25,0,1,0,0,2.5h36.6a1.25,1.25,0,1,0,0-2.5h-36.6Zm18.578-10.45a4.28,4.28,0,1,1,4.285-4.28A4.287,4.287,0,0,1,224.651,2151.69Zm0-7.94a3.655,3.655,0,1,0,3.659,3.66A3.663,3.663,0,0,0,224.651,2143.75Zm-42.232,24.74a4.68,4.68,0,1,1,4.682-4.68A4.687,4.687,0,0,1,182.419,2168.49Zm0-8.73a4.05,4.05,0,1,0,4.056,4.05A4.06,4.06,0,0,0,182.419,2159.76Zm176.62,125.53h-2.8v-38.76h2.8a0.976,0.976,0,0,1,.951,1.11v36.54A0.971,0.971,0,0,1,359.039,2285.29Zm-2.178-.62h2.178a0.4,0.4,0,0,0,.325-0.49v-36.54a0.388,0.388,0,0,0-.325-0.48h-2.178v37.51Zm-29.388,382.26H121.932a25.559,25.559,0,0,1-25.665-25.4V2158.47a25.566,25.566,0,0,1,25.665-25.4H327.473a25.3,25.3,0,0,1,25.321,25.4v483.06A25.3,25.3,0,0,1,327.473,2666.93ZM121.932,2133.7a24.933,24.933,0,0,0-25.039,24.77v483.06a24.933,24.933,0,0,0,25.039,24.77H327.473a24.665,24.665,0,0,0,24.7-24.77V2158.47a24.665,24.665,0,0,0-24.7-24.77H121.932Zm-29.106,82.52H91.9a1.25,1.25,0,0,1-1.264-1.11v-16.54a1.25,1.25,0,0,1,1.264-1.11h0.926v18.76ZM91.9,2198.09a0.644,0.644,0,0,0-.638.48v16.54a0.644,0.644,0,0,0,.638.48h0.3v-17.5H91.9Zm0.926,87.2H91.274a1.242,1.242,0,0,1-1.264-1.11v-36.54a1.25,1.25,0,0,1,1.264-1.11h1.552v38.76Zm-1.552-38.13a0.644,0.644,0,0,0-.638.48v36.54a0.652,0.652,0,0,0,.638.49H92.2v-37.51H91.274Zm1.552,88.14H91.274a1.242,1.242,0,0,1-1.264-1.11v-36.54a1.25,1.25,0,0,1,1.264-1.11h1.552v38.76Zm-1.552-38.13a0.644,0.644,0,0,0-.638.48v36.54a0.652,0.652,0,0,0,.638.49H92.2v-37.51H91.274Z' transform='translate(-90 -2129)'/>
                    <image x='18' y='65' width='233' height='415' xlink:href='../assets/images/dd-phone.jpg'/>
                    </svg>
                    <video ref='videoDD' 
                        poster='@/assets/images/dd-video-cover.jpg'
                        preload 
                        loop 
                        src='@/assets/video/dd.mp4'/>
                    <div class='image-set' ref='DDDice'>
                        <img src='@/assets/images/dd-dice-1.png'>
                        <img src='@/assets/images/dd-dice-2.png'>
                        <img src='@/assets/images/dd-dice-3.png'>
                        <img src='@/assets/images/dd-dice-4.png'>
                    </div>
                </div>
            </section>

            <!-- RED Hydrongen One -->

            <section class='section red-cover' data-cover data-anchor='production-and-merchandising-red-hydrogen'>
                <figure class='section-bg red-bg'>
                    <img src='@/assets/images/red-van.png'>
                </figure>
                <div class='section-content'>
                    <h1 class='section-title'>
                        <span class='sec-title'>Production & Merchandising</span>
                        <span class='ip-title'>Red Hydrogen</span>
                    </h1>
                    <div class='section-text'>
                        <h4>Goal</h4>
                        <p>Build Branded Experiences for RED Hydrogen</p>
                    </div>
                </div>
            </section>

            <section class='section red-1 fixed-titles'
                data-anchor='production-and-merchandising-red-hydrogen-1' 
                data-title-top='Production & Merchandising' 
                data-title-ip='Red Hydrogen'>
                
                <figure class='section-bg'/>

                <div class='section-content'>
                    <p class='medium list'>Produced vans to support branded, stunning, and yet practical touring experience</p>
                    <p class="medium list">Produced the 1 year pre-launch event tour</p>
                    <p class="medium list">Assist in developing in store brand merchandising experience</p>
                </div>
                
                <div class='section-media'>
                    <figure class='red-event-1'/>
                    <figure class='red-event-2'/>
                    <figure class='red-event-3'/>
                </div>
            </section>

            <!-- Film Threat -->

            <section class='section film-threat-cover' 
                data-video
                data-cover 
                data-anchor='design-before-and-after'>
                <div class='section-content'>
                    <h1 class='section-title'>
                        <span class='sec-title'>Design</span>
                        <span class='ip-title'>Film Threat</span>
                    </h1>
                    <div class='section-text'>
                        <h4>Goal</h4>
                        <p>ReBrand Visual Identity, Modernize Brand, Improve Usability, Increase Mobile/Web Browser KPIs</p>
                    </div>
                </div>
                <figure class='film-threat-bg film-threat-before'>
                    <div class='screen'>
                        <h3>Before</h3>
                        <img src='@/assets/images/film-threat-before-home.jpg' alt='Before'>
                    </div>
                </figure>
                <figure class='film-threat-bg film-threat-after'>
                    <div class='screen'>
                        <h3>After</h3>
                        <video ref='videoFT' 
                            poster='@/assets/images/film-threat-cover.jpg'
                            preload 
                            loop 
                            src='@/assets/video/ft.mp4'/>
                    </div>
                </figure>
            </section>

            <section class='section film-threat fixed-titles'
                data-anchor='film-threat-design-optimization' 
                data-title-left='Design Optimization' 
                data-title-top='Content ROI: Planning Brand'
                data-title-ip='Film Threat'
                data-slides>

                <div class="slide film-threat-1">
                    <div class='section-content'>
                        <div class='before'>
                            <h4>Before Optimization</h4>
                            <ul>
                                <li><strong>1.15</strong> Pages Per Visitor</li>
                                <li><strong>0:41</strong> Seconds on Site</li>
                            </ul>
                        </div>
                        <figure class='film-threat-devices'>
                            <img src='@/assets/images/film-threat-devices.png' alt='Film Threat Devices'>
                        </figure>
                        <figure class='film-threat-optimization'>
                            <GAStat
                                v-for='(stat, index) in FTStats'
                                :key='stat.title' 
                                :title='stat.title'
                                :percent='stat.percent'
                                :comparison='stat.comparison'
                                :index='parseInt(index)'/>
                        </figure>
                        <div class='after'>
                            <h4>After Optimization</h4>
                            <ul>
                                <li><strong>4.69</strong> Pages per Visitor</li>
                                <li><strong>1:55</strong> Minutes on Site</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="slide film-threat-2">
                     <div class='section-content'>
                        <h3>Organizational Planning Brand</h3>
                        <p>How MT's program can deliver exponential revenue returns and ultimately pay for itself.</p>
                        <p>$4M in Revenue from MT Content versus $2M in the same time frame from the period prior to MT's start date.</p>
                    </div>
                    <figure class='film-threat-planning'>
                        <img src='@/assets/images/film-threat-planning.jpg' alt='Film Threat Planning'>
                    </figure>
                </div>
            </section>

            <section class='section thank-you' data-cover data-anchor='thank-you'>
                <h1 class='section-title'>
                    <span class='sec-title'>Thank You</span>
                    <a href='mailto:bethany@magicalthreads.co'><span class='ip-title'>bethany@magicalthreads.co</span></a>
                </h1>
            </section>

        </full-page>
    
        <transition name='fixed-titles'>
            <FixedTitles
                v-show='showFixedTitles'
                :fixedTitleTop='fixedTitleTop'
                :fixedTitleIp='fixedTitleIp'
                :fixedTitleLeft='fixedTitleLeft'
                :fixedSlideCount='fixedSlideCount'/>
        </transition>
  </div>
</template>

<script>
import { TweenMax, TimelineMax } from 'gsap'
import '@/scripts/gsap.SplitText'
import FixedTitles from '@/components/FixedTitles.vue'

const GAStat = {
    props: {
        title: {
            type: String
        },
        percent: {
            type: String,
        },
        comparison: {
            type: String
        },
        index: {
            type: Number
        }
    },
    render(h) {
        const title = h('h5', { class: 'title' }, this.title)
        const percent = h('p', { class: 'percent' }, `${this.percent}%`)
        const comparison = h('p', { class: 'comparison' }, this.comparison)
        const graph = h('img', { 
            class: 'graph', 
            attrs: {
                src: require(`@/assets/images/film-threat-optimization-${this.index + 1}.svg`)
            }
        })
        const children = [title, percent, comparison, graph]
        return h('div', {
            class: 'ga-stat'
        }, children)
    }
}

export default {
    name: 'home',
    components: {
        FixedTitles,
        GAStat
    },
    data() {
        return {
            fixedTitleIp: '',
            fixedTitleTop: '',
            fixedTitleLeft: '',
            fixedSlideCount: '',
            showFixedTitles: false,
            currentSlide: null,
            options: {
                scrollingSpeed: 750,
                afterRender: this.afterRender,
                afterLoad: this.afterLoad,
                onLeave: this.onLeave,
                onSlideLeave: this.onSlideLeave,
                afterSlideLoad: this.afterSlideLoad,
                scrollBar: false,
                sectionSelector: '.section',
                slideSelector: '.slide',
                navigation: false,
                dragAndMove: true,
                controlArrows: false,
                slidesNavigation: false,
                slidesNavPosition: 'bottom',
                licenseKey: '22B903D5-8F34492D-88AEF381-A200A959'
            },
            FTStats: [{
                title: 'Pageviews',
                percent: '219.44',
                comparison: '6,229 vs. 1,950'
            }, {
                title: 'Page / Session',
                percent: '306.69',
                comparison: '4.69 vs. 1.15'
            }, {
                title: 'Avg. Session Duration',
                percent: '183.50',
                comparison: '00:01:55 vs. 00:00:41'
            }, {
                title: 'Bouce Rate',
                percent: '-99.00',
                comparison: '0.90% vs. 90.01%'
            }]
        }
    },
    computed: {
        slidesWithVideos() {
            const { 
                videoPOTA, 
                videoPOTABook, 
                videoPOTAmicrosite, 
                videoDD, 
                videoFT
            } = this.$refs

            // Play video for slides with video elements
            const slidesWithVideos = [
                { className: 'pota-1', video: videoPOTA },
                { className: 'pota-3', video: videoPOTAmicrosite },
                { className: 'pota-4', video: videoPOTABook },
                { className: 'dd-1', video: videoDD },
                { className: 'film-threat-cover', video: videoFT }
            ]
            return slidesWithVideos
        }
    },
    methods: {
        POTACoverTimeline() {
            return new TimelineMax()
            .fromTo('.pota-cover .section-content img', 1, {
                autoAlpha: 0,
                y: 50
            }, {
                autoAlpha: 1,
                y: 0,
                ease: Power4.easeOut
            }, 3.4)
            .fromTo('.section-bg.pota-bg .pota-carlos', 10, {
                y: '28%',
            }, {
                y: '3%',
                scale: 1,
                ease: Back.easeOut.config(1)
            }, 0)
        },
        DDCoverTimeline() {
            return new TimelineMax()
            .fromTo('.section-bg.dd-bg', 5, {
                filter: 'blur(15px)',
                opacity: 0.5,
                y: '-40%',
                scale: 1.5,
            }, {
                filter: 'blur(0px)',
                opacity: 1,
                scale: 1,
                y: '0%',
                ease: Sine.easeOut
            })
        },
        redCoverTimeline() {
            return new TimelineMax()
            .fromTo('.section-bg.red-bg', 10, {
                scale: 1.15,
            }, {
                scale: 1,
                transformOrigin: '100% 100%',
                ease: Sine.easeOut
            })
        },
        slideCoverTimeline(slide) { 

            // Cancel if null
            if (!slide) return
            
            const title = new SplitText(slide.querySelector('.sec-title'))
            const ip = new SplitText(slide.querySelector('.ip-title'))

            // Check if slide cover has slide cover subtitle & description
            const titleH4 = slide.querySelector('.section-text h4')
            const subtitle = !titleH4 ? false : new SplitText(titleH4)
            const descText = slide.querySelector('.section-text p')
            const desc = !descText ? false : new SplitText(descText, { type: 'chars, words, lines', linesClass: 'line line++'})

            const timeline = new TimelineMax()
            .staggerFromTo(title.chars, 2, {
                autoAlpha: 0,
                y: 50,
            }, {
                autoAlpha: 1,
                y: 0,
                ease: Power4.easeOut,
                delay: this.options.scrollingSpeed/1000,
            }, 0.025)
            .staggerFromTo(ip.chars, 2, {
                autoAlpha: 0,
                y: 50,
            }, {
                autoAlpha: 1,
                y: 0,
                ease: Power4.easeOut,
            }, 0.025, '-=2')

            // Check if slide cover has a subtitle
            if (subtitle) {
                timeline.staggerFromTo(subtitle.chars, 2, {
                    autoAlpha: 0,
                    y: 15,
                }, {
                    autoAlpha: 1,
                    delay: 1,
                    y: 0,
                    ease: Power4.easeOut,
                }, 0.1, '-=2')
            }
            
            // Check if slide cover has a description
            if (desc) {
                timeline.staggerFromTo(desc.lines, 2, {
                    autoAlpha: 0,
                    y: 30,
                }, {
                    autoAlpha: 1,
                    y: 0,
                    ease: Power4.easeOut,
                }, 0.1, '-=2')
            }

            // These conditionals append a custom animation timeline for the queried slide class
            if (slide.classList.contains('pota-cover')) {
                timeline.add(this.POTACoverTimeline(), 0)
            }

            if (slide.classList.contains('dd-cover')) {
                timeline.add(this.DDCoverTimeline(), 0)
            }

            if (slide.classList.contains('red-cover')) {
                timeline.add(this.redCoverTimeline(), 0)
            }

            return timeline
        },
        playVideo(videoElem) {
            const playPromise = videoElem.play()
            if (playPromise !== undefined) {
                playPromise
                .then(() => {})
                .catch(error => console.warn(error.message, 'Clickity, click, that mouse.'))
            }
            return playPromise
        },
        playSlideWithVideo(slide) {
            this.slidesWithVideos.forEach(videoSlide => {
                 if (slide.classList.contains(videoSlide.className)) {
                    this.playVideo(videoSlide.video)
                }
            })
        },
        /**
         * This callback is fired just after the structure of the page is generated. 
         */
        afterRender() {
            this.slideCoverTimeline(this.currentSlide)
        },
        /**
         * @param {Object} origin - Section of origin.
         * @param {Object} destination - Destination section.
         * @param {String} direction - It will take the values up or down depending on the scrolling direction.
        */
        onLeave(origin, destination, direction) {

            const { item } = destination
            const {slides} = origin.item.dataset

            const fp = this.$refs.fullpage.api
            const activeSlide = fp.getActiveSlide()

            // If sections have horizontal slides
            if(slides !== undefined) {
                if (!activeSlide.isLast && direction === 'down') {
                    fp.moveSlideRight()
                    return false
                }
                else if (!activeSlide.isFirst && direction === 'up') {
                    fp.moveSlideLeft()
                    return false
                }
            }
            
            // Toggle the fixed titles UI
            this.showFixedTitles = item.classList.contains('fixed-titles') ? true : false
        
            const isCoverSlide = item.dataset.cover !== undefined
            
            // Animate the section covers
            if (isCoverSlide) {
                this.slideCoverTimeline(item)
            }

            document.body.classList.toggle('is-cover', isCoverSlide)
        },
        /**
         * @param {Object} origin - Section of origin.
         * @param {Object} destination - Destination section.
         * @param {String} direction - It will take the values up or down depending on the scrolling direction.
         */
        afterLoad(origin, destination, direction) {

            const { item } = destination

            // Need it for afterRender()
            this.currentSlide = item

            // Update the fixed titles if section has the className
            const hasVideo = item.dataset.video !== undefined ? true : false
            
            this.updateFixedTitles(item)

            // Play the video is item has slides 
            if (hasVideo) {
                const videoSlide = item.querySelector('.slide')
                const slideToPlay = !videoSlide ? item : videoSlide
                this.playSlideWithVideo(slideToPlay)
            }
        },
        afterSlideLoad(section, origin, destination, direction) {
          
            // FullPage
            const fp = this.$refs.fullpage.api
            const activeSlide = fp.getActiveSlide()
            
            this.updateFixedTitles(section.item, activeSlide)
            this.playSlideWithVideo(activeSlide.item)
        },
        onSlideLeave(section, origin, destination, direction) {
            // console.log('onSlideLeave', {section, origin, destination, direction});
        },
        /**
         * @param {HTMLElement} section - The slide element
         */
        updateFixedTitles(section, slide) {

            if (!section) {
                this.fixedTitleTop = ''
                this.fixedTitleIp = ''
                this.fixedTitleLeft = ''
                this.fixedSlideCount = ''
                return
            }
            
            const { titleTop, titleIp, titleLeft } = section.dataset
            const slidesTotal = Array.from(section.querySelectorAll('.slide')).length 
            const slidesCount = !slide ? `1 of ${slidesTotal}` : `${(slide.index + 1).toString()} of ${slidesTotal}`

            this.fixedTitleTop = titleTop
            this.fixedTitleIp = titleIp
            
            // Left Title and Slide Count are optional
            this.fixedTitleLeft = !titleLeft ? '' : titleLeft
            this.fixedSlideCount = slidesCount === '1 of 0' ? '' : slidesCount
        },
        /**
         * @param {Object} event - The event object
         */
        onMouseMove(event) {

            const { potaBooks, DDDice } = this.$refs

            // Planet of The Apes
            this.mouseParallax(event, '.pota-carlos', -20)
            this.mouseParallax(event, '.pota-cover .section-content', -10)
            Array.from(potaBooks.children).forEach(book => this.mouseParallax(event, book.firstElementChild, -Math.random() * 20))

            // Dungeons & Dragons
            this.mouseParallax(event, '.dd-cover .section-content', -10)
            this.mouseParallax(event, '.dd-cover .section-bg', -50)
            Array.from(DDDice.children).forEach(dice => this.mouseParallax(event, dice, -Math.random() * 40))
            
            // Red Hydrogen
            this.mouseParallax(event, '.red-bg img', -45, true, false)
            this.mouseParallax(event, '.red-cover .section-content', -10)
        },
        /**
         * @param {Object} event - Event object
         * @param {HTMLElement} target
         * @param {Number} movement
         * @param {Boolean} x - If "x" movement should be applied
         * @param {Boolean} y - If "y" movement should be applied
         */
        mouseParallax(event, target, movement, x = true, y = true) {
            const _x = event.clientX
            const _y = event.clientY
            if (target) {
                const xMove = x ? (_x - window.innerWidth/2) / window.innerWidth * movement : 0
                const yMove = y ? (_y - window.innerHeight/2) / window.innerHeight * movement : 0
                TweenMax.to(target, 1, {
                    x: xMove,
                    y: yMove,
                    ease: Power1.easeOut
                })
            }
        }
    },
    mounted() {
        document.addEventListener('mousemove', this.onMouseMove)
    },
}
</script>

<style lang='scss'>

@import './../styles/mixins';
@import './../styles/vars';

.section {
    position: relative;
    overflow: hidden;
    .fp-tableCell {
        perspective: 800px;
        transform-style: preserve-3d;
    }
}

.section-bg {
    position: absolute;
    top: 0; right: 0; bottom: 0; left: 0;
}

h1.section-title {
    position: relative;
    z-index: 1;
    line-height: 1.1;
    display: flex;
    flex-direction: column;
    .sec-title {
        display: inline-block;
    }
    .ip-title {
        display: inline-block;
        font-family: $font-light-headline;
    }
}

p.large {
    font-family: $font-bold-text;
    @include fluid-type(24px, 46px);
}

.section-text {
    line-height: 1.5;
}

p.medium {
    @include fluid-type(12px, 30px);
    line-height: 1.5;
}

p.list {
    line-height: 1.5;
    position: relative;
    &:before {
        content: '—';
        position: absolute;
        color: gray;
        left: 0;
        font-family: $font-light-text;
        transform: translateX(calc(-100% - #{vw(15)}));
    }
}

#download-pdf {
    position: fixed;
    bottom: vw(30);
    right: 0;
    color: gray;
    z-index: 9002;
    text-decoration: none;
    font-family: $font-regular-text;
    display: flex;
    align-items: center;
    transition: all 0.15s ease-in-out;
    width: vw(90);
    writing-mode: tb;
    opacity: 1;
    .icon {
        width: 16px;
        height: 16px;
        margin-top: 15px;
    }
    &:hover {
        color: white;
    }
}

.is-cover #download-pdf {
    opacity: 0;
    pointer-events: none;
}

/* Planet of The Apes 
-------------------------------------------
*/

section.pota-cover {
    background: white;
    color: black;
    .section-bg {
        display: flex;
        justify-content: center;
        background: url('../assets/images/pota-forest.jpg') 50% 50%/cover no-repeat;
    }
    .pota-carlos {
        position: absolute;
        width: 130vw;
        bottom: -15vw;
        margin: 0 0 0 6vw;
        z-index: 2;
    }
    .section-content {
        text-align-last: left;
        position: absolute;
        top: vw(100); left: vw(180);
        img {
            display: block;
            margin: vw(30) 0 0 0;
            width: 50%;
        }
    }
    .section-text {
        margin-top: vw(30);
        width: vw(460);
        display: flex;
        p {
            width: 70%;
        }
        p > div {
            white-space: nowrap;
        }
    }
    h4 {
        width: vw(90);
        margin-right: vw(30);
    }
}

.pota {
    background: black;
    color: white;
    .section-bg {
        position: absolute;
        width: vw(720);
        top: 0; right: 0; bottom: 0;
        background: $color-black-1;
    }
    .section-content {
        width: vw(360);
        position: absolute;
        top: 0; 
        left: vw(180);
        bottom: 0;
        display: flex;
        justify-content: center;
        flex-direction: column;
    }
    .slide-count {
        color: gray;
        margin-bottom: vw(30);
    }
    .section-media {
        position: absolute;
        right: vw(90);
        bottom: 0;
        top: 0;
        video {
            width: vw(720);
        }
    }
    .section-text {
        margin-top: vw(30);
        width: vw(460);
        display: flex;
    }
    h4 {
        width: vw(90);
        margin-right: vw(30);
    }
}

.pota-1 {
    .section-media {
        display: flex;
        align-items: center;
    }
    .image-set {
        position: absolute;
        width: vw(720);
        padding-bottom: 28vw;
        span {
            position: absolute;
            img {
                width: vw(120);
            }
        }
    }

    .image-set span:nth-of-type(1) {
        top: 0;
        left: vw(60);
        transform: translateY(calc(-100% + #{vw(60)}));
    }
    .image-set span:nth-of-type(2) {
        top: 0;
        left: vw(400);
        transform: translateY(calc(-100% + #{vw(60)}));
        z-index: -1;
    }
    .image-set span:nth-of-type(3) {
        bottom: 0;
        left: 0;
        transform: translate(-50%, 50%);
    }
    .image-set span:nth-of-type(4) {
        bottom: 0;
        left: vw(190);
        transform: translateY(calc(100% - #{vw(60)}));
    }
    .image-set span:nth-of-type(5) {
        bottom: 0;
        left: vw(530);
        transform: translateY(50%);
    }
}

.pota-2 {
    .section-media {
        width: vw(720);
        display: grid;
        grid: repeat(2, 1fr)/auto;
        grid-gap: vw(10) 0;
        figure {
            background: $color-black-1 50% 50%/cover no-repeat;
            width: 100%;
            height: 100%;
        }
        figure.pota-nycc-1 {
            background-image: url('../assets/images/pota-nycc-1.jpg');
        }
        figure.pota-nycc-2 {
            background-image: url('../assets/images/pota-nycc-2.jpg');
        }
    }
}

.pota-3 {
    .section-content {
        width: 35vw;
    }
    .section-media {
        display: flex;
        align-items: center;
        z-index: 2;
        video {
            clip-path: inset(0 0 0 #{vw(4)});
            transform: translateY(-15%);
        }
    }
    .image-set {
        height: 30vh;
        position: absolute;
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        grid-gap: 0 vw(40);
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        width: 50%;
        img {
            align-self: center;
            justify-self: center;
            height: vw(120);
            display: inline-block;
            image-rendering: pixelated;
        }
    }
    .section-bg.bg-sf {
        background: url('../assets/images/pota-sf.jpg') 50% 130%/140% auto no-repeat;
        position: absolute;
        left: initial;
        top: 0; bottom: 0;
        right: vw(90);
        width: vw(630);
    }
}

.pota-4 {
    .section-content {
        width: 35vw;
    }
    .section-media {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: center;
        video {
            width: vw(540);
            margin: vw(15) 0;
        }
    }
    .pota-ad {
        width: vw(720);
        display: block;
    }
    .pota-content-clip {
        width: vw(215);
        display: block;
    }
}

.pota-5 {
    .section-content {
        width: 35vw;
    }
    .section-media {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: center;
    }
    .pota-messaging {
        width: vw(660);
        display: block;
        transform: translateY(#{vw(60)});
    }
    .row {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-gap: 0 vw(30);
        transform: translateY(#{vw(-30)});
        padding-right: vw(30);
    }
    .pota-fb {
        width: vw(260);
        display: block;
    }
    .pota-twitter {
        width: vw(260);
        display: block;
    }
}

.pota-6 {
    .section-media {
        width: vw(660);
        display: grid;
        grid: repeat(2, 1fr)/auto;
        grid-gap: vw(10) 0;
        figure {
            background: $color-black-1 50% 50%/cover no-repeat;
            width: 100%;
            height: 100%;
        }
        figure.pota-artist-1 {
            background-image: url('../assets/images/pota-artist-1.jpg');
        }
        figure.pota-artist-2 {
            background-image: url('../assets/images/pota-artist-2.jpg');
        }
    }
}

/* Dungeons & Dragons
-------------------------------------------
*/

section.dd-cover {
    background: black;
    color: white;
    .section-bg {
        display: flex;
        justify-content: center;
        background: url('../assets/images/dd-cover.jpg') 50% 50%/cover no-repeat;
    }
    .section-content {
        text-align-last: left;
        position: absolute;
        top: vw(100); left: vw(180);
    }
    .section-text {
        margin-top: vw(30);
        width: vw(250);
    }
    h4 {
        margin-bottom: vw(30);
    }
}

section.dd-1 {
    .section-bg {
        font-family: $font-light-text;
        background: $color-black-1;
        top: initial; left: initial;
        position: absolute;
        bottom: 0; right: vw(90);
        width: vw(820);
        height: 50%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 0 vw(180);
    }
    p:not(.list) {
         margin-bottom: vw(30);
    }
    .x-large {
        font-family: $font-bold-headline;
        @include fluid-type(24px, 52px);
        color: yellow;
        line-height: 2;
        background: -webkit-linear-gradient(#ff807b, #ffc0a2);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        span {
            animation: burn 1.5s ease-in-out infinite alternate;
        }
        span:nth-child(2) {
            animation: burn 2s ease-in-out infinite alternate 0.2s;
        }
        span:nth-child(3) {
            animation: burn 1s ease-in-out infinite alternate 0.1s;
        }
        
    }
    @keyframes burn {
    0% {
        text-shadow: 
            0 0 5px rgba(#fefcc9, 0.1),
            1px -10px 30px rgba(#feec85, 0.4),
            -3px -5px 12px rgba(#ffae34, 0.3),
            1px -9px 10px rgba(#ec760c, 0.13),
            -2px -2px 25px rgba(#cd4606, 0.4),
            0 -4px 20px rgba(#973716, 0.4),
            1px -1px 30px rgba(#451b0e, 0.1);
    }
    50% {
        text-shadow: 
            -1px 0 15px rgba(#fefcc9, 0.1),
            0 -5px 10px rgba(#feec85, 0.3),
            3px -3px 10px rgba(#ffae34, 0.05),
            -1px -8px 11px rgba(#ec760c, 0.15),
            3px -10px 19px rgba(#cd4606, 0.1),
            0 -1px 32px rgba(#973716, 0.2),
            -2px -2px 8px rgba(#451b0e, 0.1);
    }
    100% {
        text-shadow: 
            0 0 5px rgba(#fefcc9, 0.16),
            -2px -1px 1px rgba(#feec85, 0.1),
            3px -3px 10px rgba(#ffae34, 0.4),
            -2px -3px 11px rgba(#ec760c, 0.13),
            1px -12px 19px rgba(#cd4606, 0.6),
            2px -4px 32px rgba(#973716, 0.16),
            -2px -9px 20px rgba(#451b0e, 0.2);
    }
    }
    video {
        width: vw(360);
        position: absolute;
        left: vw(270);
        top: calc(50% - #{vw(30)});
        box-shadow: 0 10px 60px rgba(black, 0.75);
        clip-path: inset(0 2px 0 2px);
    }
    .section-content {
        position: absolute;
        top: vw(90);
        left: vw(540);
        height: calc(40% - #{vw(90)});
        display: flex;
        justify-content: center;
        flex-direction: column;
    }
    .dd-phone {
        width: vw(220);
        stroke: white;
        stroke-width: 0.5;
        position: absolute;
        top: vw(120);
        left: vw(120);
    }
    .image-set {
        position: absolute;
        bottom: 0; right: 0;
        width: vw(900);
        height: 50%;
        z-index: 2;
        img {
            position: absolute;
            width: 6%;
        }
        img:nth-of-type(1) {
            left: vw(270);
            top: -10%;
        }
        img:nth-of-type(2) {
            left: vw(515);
            top: -10%;
        }
        img:nth-of-type(3) {
            left: vw(750);
            top: vw(50);
        }
        img:nth-of-type(4) {
            left: vw(750);
            bottom: vw(60);
        }
    }
}

/* Red Hydrongen One
-------------------------------------------
*/

section.red-cover {
    background: white;
    color: black;
    .section-bg {
        background: url('../assets/images/red-bg.jpg') 50% 50%/cover no-repeat;
        img {
            position: absolute;
            bottom: 0;
            right: 0;
            width: 100vh;
        }
    }
    .section-content {
        position: absolute;
        top: vw(100); left: vw(180);
    }
    .section-text {
        margin-top: vw(30);
        width: vw(260);
    }
    h4 {
        margin-bottom: vw(30);
    }
}

section.red-1 {
    background: black;
    color: white;

    .section-bg {
       width: vw(900);
        background: $color-black-1;
    }
    .section-content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        position: absolute;
        top: 0; bottom: 0; left: vw(180);
        width: vw(360);
        p.list {
            font-family: $font-bold-text;
            margin-bottom: vw(30);
        }
    }
    .section-media {
        position: absolute;
        top: 0; bottom: 0;
        right: vw(90);
        width: vw(630);
        display: grid;
        grid-template-rows: vw(530) auto;
        grid-template-columns: repeat(2, 1fr);
        grid-gap: vw(10);
        figure {
            background: $color-black-1 50% 50%/cover no-repeat;
            width: 100%;
            height: 100%;
        }
        figure.red-event-1 {
            background-image: url('../assets/images/red-event-1.jpg');
        }
        figure.red-event-2 {
            background-image: url('../assets/images/red-event-2.jpg');
        }
        figure.red-event-3 {
            background-image: url('../assets/images/red-event-3.jpg');
            grid-column: 1/3;
        }
    }
}

/* Film Threat
-------------------------------------------
*/

.film-threat-cover {
    background: url('../assets/images/ft-bg.jpg') 50% 50%/cover;
    color: black;
    .fp-tableCell {
        display: grid;
        grid-template-columns: 40% 60%;
        grid-template-rows: 50% 50%;
    }
    h1 {
        color: white;
        width: 100%;
    }
    .section-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        grid-column: 1/3;
        padding: 0 vw(180);
    }
    .section-text {
        color: white;
        margin-top: vw(15);
        width: 90%;
        h4 {
            margin-bottom: vw(5);
        }
    }
    h3 {
        display: inline-block;
        background: black;
        margin-bottom: vw(-15);
        color: white;
        padding: vw(6) vw(10);
        position: relative;
        z-index: 1;
    }
    .screen {
        width: 100%;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        transform: translate3d(0, -15%, 0);
        img {
            height: auto;
            width: 60%;
            display: block;
            box-shadow: 0 4px 10px rgba(black, 0.3);
        }
        video {
            width: 90%;
            display: block;
            clip-path: inset(#{vw(19)} 0 #{vw(19)} 0);
        }
    }
}

.film-threat-cover .film-threat-bg {
    display: flex;
    align-items: flex-start;
    justify-content: center;
}

.film-threat-cover .film-threat-before {
    background: darken(white, 5%);
    left: 0;
    grid-column: 1/2;
}

.film-threat-cover .film-threat-after {
    background: darken(white, 10%);
    right: 0;
    grid-column: 2/3;
    h3 {
        margin-bottom: vw(-30);
    }
}

// Children Slides 
.film-threat {
    background: darken(white, 5%);
    color: black;
}

.film-threat-devices {
    position: absolute;
    top: vw(60); right: 0; bottom: vw(300); left: 0;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    z-index: 10;
    img {
        left: -5%;
        position: relative;
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
}

.film-threat-1 .section-content {
    position: absolute;
    top: 0; right: 0; bottom: 0; left: vw(180);
    display: flex;
    align-items: center;
    justify-content: space-between;
    h4 {
        margin-bottom: vw(30);
    }
    ul {
        margin: 0;
        padding: 0;
        list-style: none;
        @include fluid-type(24px, 30px);
    }
    ul li {
        margin-bottom: vw(15);
    }
    .before {
        text-align: left;
        h4 {
            color: gray;
        }
    }
    .after {
        text-align: right;
        padding: vw(60) vw(180) vw(60) vw(30);
        background: white;
        h4 {
            color: lighten(green, 15%);
        }
    }
    
}

.film-threat-2 .section-content {
    position: absolute;
    left: 0;
    padding-left: vw(180);
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
    width: 35%;
    h3 {
        font-family: $font-bold-text;
        @include fluid-type(24px, 46px);
    }
    h3, p {
        margin-bottom: vw(30);
    }  
}

.film-threat-2 .fp-tableCell {
    display: flex;
    align-items: center;
    justify-content: center;
}

.film-threat-2 .film-threat-planning {
    position: absolute;
    width: 60%;
    top: 0; right: 0;
    bottom: 0;
    padding-right: vw(90);
    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
}

.film-threat-optimization {
    position: absolute;
    right: vw(180); bottom: vw(250); left: 0;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    transform: translateY(100%);
}

.ga-stat {
    text-align: center;
    position: relative;
    .title {
        @include fluid-type(16px, 24px);
        margin: 0 0 vw(10);   
    }
    .percent {
        @include fluid-type(24px, 30px);
        color: lighten(green, 15%);
        margin: 0 0 vw(5);
    }
    .comparison {
        @include fluid-type(12px, 18px);
        color: darken(gray, 15%);
        margin-bottom: vw(15);
    }
    .graph {
        width: 70%;
        margin: auto;
        display: block;
    }
}

.fp-viewing-film-threat-design-optimization-0,
.fp-viewing-film-threat-design-optimization-1 {
    #download-pdf:hover,
    .fixed-titles {
        color: black;
    }
}

/* Thank You
-------------------------------------------
*/

.section.thank-you {
    color: white;
    text-align: center;
    .ip-title {
        font-family: $font-regular-text;
        @include fluid-type(18px, 24px);
        color: white;
    }
}

/* Fixed Titles
-------------------------------------------
*/

.fixed-titles-enter-active {
    transition: all 0.3s ease-out;
}

.fixed-titles-leave-active {
    transition: all 0.3s ease-in;
}

.fixed-titles-enter, 
.fixed-titles-leave-to {
    opacity: 0,
}

.fixed-titles-enter-to, 
.fixed-titles-leave {
    opacity: 1,
}

</style>
